import type { ReactNode } from "react";
import { StyleSheet, View } from "react-native";

import { CONTENT_MAX_WIDTH } from "@/components/site-header";

/**
 * The page's content column: centred, capped at the same width as the header's
 * inner row (imported so the two cannot drift), full-width below the cap.
 * `alignSelf: "center"` because the root shell is a plain flex column — the
 * column centres itself rather than asking every parent to centre it.
 */
export function PageColumn({ children }: { children: ReactNode }) {
  return <View style={styles.column}>{children}</View>;
}

const styles = StyleSheet.create({
  column: {
    alignSelf: "center",
    maxWidth: CONTENT_MAX_WIDTH,
    width: "100%",
  },
});
